import { reportCommentUtils } from "../utils";
import { ReportListItem } from "./ListItem";

export const WhatIsHappening = () => {
  return (
    <>
      {reportCommentUtils.whatIsHappeningListItems.map((item) => (
        <ReportListItem key={item} label={item} />
      ))}
    </>
  );
};
